export default __webpack_public_path__ + "static/media/excel-logo.2971241a.png";